import "./podcast-grid.scss";

(function () {
	// Guard for WP inline data
	if (typeof PG_Ajax === "undefined" || !PG_Ajax.ajax_url) return;

	const blocks = document.querySelectorAll(".podcast-grid[data-pg]");
	if (!blocks.length) return;

	blocks.forEach((root) => {
		const grid = root.querySelector(".pg-grid");
		const actions = root.querySelector(".pg-actions");
		const btn = root.querySelector("[data-pg-load]");
		if (!grid || !btn) return;

		let page = parseInt(root.getAttribute("data-next-page") || "2", 10);
		const perPage = parseInt(
			root.getAttribute("data-per-page") || "20",
			10
		);
		const orderby = root.getAttribute("data-orderby") || "date";
		const order = root.getAttribute("data-order") || "DESC";
		const relation = root.getAttribute("data-relation") || "IN";
		const termsStr = (root.getAttribute("data-terms") || "").trim();
		const terms = termsStr
			? termsStr
					.split(",")
					.map((n) => parseInt(n, 10))
					.filter(Boolean)
			: [];

		let busy = false;

		btn.addEventListener("click", async () => {
			if (busy) return;
			busy = true;
			btn.disabled = true;
			btn.textContent = "Loading…";

			try {
				const form = new FormData();
				form.append("action", "constellation_pg_load");
				form.append("nonce", PG_Ajax.nonce);
				form.append("page", String(page));
				form.append("per_page", String(perPage));
				form.append("orderby", orderby);
				form.append("order", order);
				form.append("relation", relation);
				terms.forEach((t) => form.append("terms[]", String(t)));

				const res = await fetch(PG_Ajax.ajax_url, {
					method: "POST",
					credentials: "same-origin",
					body: form,
				});
				const json = await res.json();

				if (!json?.success)
					throw new Error(json?.data?.message || "Request failed");

				// Append new items
				if (json.data.html) {
					const frag = document
						.createRange()
						.createContextualFragment(json.data.html);
					grid.appendChild(frag);
				}

				if (json.data.has_more) {
					page = json.data.next_page || page + 1;
					btn.disabled = false;
					btn.textContent = "Load more";
				} else {
					btn.remove();
					actions.remove();
					actions.innerHTML = "";
				}
			} catch (err) {
				console.error("[podcast-grid] load more error:", err);
				btn.disabled = false;
				btn.textContent = "Load more";
			} finally {
				busy = false;
			}
		});
	});
})();
